module.exports = __webpack_public_path__ + "img/AUTO_PHOTO_DESACTIVE.ebf89cd1.svg";